export const types = {
  FETCH_NOTIFICATIONS: '@NOTIFICATIONS/FETCH_NOTIFICATIONS',
  REFRESH_NOTIFICATIONS: '@NOTIFICATIONS/REFRESH_NOTIFICATIONS',
  DISABLE_NOTIFICATIONS: '@NOTIFICATIONS/DISABLE_NOTIFICATIONS',
  FILL_NOTIFICATIONS: '@NOTIFICATIONS/FILL_NOTIFICATIONS',
  CLEAR: '@NOTIFICATIONS/CLEAR'
};